export const FINISHER_ROAD = 'https://hdor.com/app/assets/images/sc2021/roadv2.jpeg';
export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];
export const SPACING_BETWEEN_WIDGETS = 8;
// export const SPACING_BETWEEN_WIDGETS_MOBILE = 4;
export const HEIGHT_OF_WIDGET = 120;
export const FINISHER_WALKER = 'https://hdor.com/app/assets/images/sc2021/walker.gif';
export const HEADER_STEP_ACTIVITY = ['Date', 'Mapped Data', 'Points', 'Source', ''];
export const HEADER_RUNNING_ACTIVITY = [
  'Date',
  'Distance',
  'Points(M/P/E)',
  'Pace',
  'Time(hh:mm:ss)',
  'Source',
  '',
];
export const HEADER_CYCLING_ACTIVITY = [
  'Date',
  'Distance',
  'Points(M/S/E)',
  'Speed',
  'Elapsed/Moving Time',
  'Source',
  '',
];
export const SOCIAL_LINK_PLATFORM = {
  web: 'WEB',
  googleStore: 'GOOGLE',
  appleStore: 'APPLE',
};

export const AVAILABLE_CONNECTED_APPS = [
  { name: 'garmin', label: 'Garmin' },
  { name: 'fitbit', label: 'Fitbit' },
  { name: 'strava', label: 'Strava' },
  { name: 'mapMyRun', label: 'Map My Run' },
  { name: 'mapMyRide', label: 'Map My Ride' },
];

// { name: "polar", label: "Polar" },
// { name: "wahoo", label: "Wahoo" },
export const ALLOWED_BETWEEN_DATE_CONNECTED_APP = [
  { id: 'garmin', activity: 1, summary: 1 },
  { id: 'fitbit', activity: 2, summary: 2 },
  { id: 'strava', activity: 2, summary: 2 },
  { id: 'mapMyRun', activity: 1, summary: 1 },
  { id: 'mapMyRide', activity: 1, summary: 1 },
];

// { id: "polar", activity: 1, summary: 1 },
// { id: "wahoo", activity: 1, summary: 1 }

export const SPORTS_TYPE = {
  RUNNING: 'running',
  CYCLING: 'cycling',
  STEPS: 'steps',
};

export const SUPPORTED_SPORTS_GARMIN = ['running', 'cycling', 'steps', 'walk'];

export const SUPPORTED_SPORTS_GOOGLEFIT = ['running', 'cycling', 'steps', 'walk'];

export const SUPPORTED_SPORTS_FITBIT = ['running', 'cycling', 'steps', 'walk'];
export const SUPPORTED_SPORTS_STAVA = ['running', 'walk', 'cycling'];
export const SUPPORTED_SPORTS_MAPMYRIDE = ['running', 'walk', 'cycling'];
export const SUPPORTED_SPORTS_MAPMYRUN = ['running', 'walk', 'cycling'];
export const SUPPORTED_SPORTS_POLAR = ['running', 'walk', 'cycling'];
export const SUPPORTED_SPORTS_WAHOO = ['running', 'walk', 'cycling'];

export const GARMIN_SOCIAL_LINKS = {
  googleStore:
    'https://play.google.com/store/apps/details?id=com.garmin.android.apps.connectmobile',
  appleStore: 'https://apps.apple.com/us/app/garmin-connect/id583446403',
};

export const STAVA_SOCIAL_LINKS = {
  googleStore: 'https://play.google.com/store/apps/details?id=com.strava',
  appleStore: 'https://apps.apple.com/us/app/strava-run-ride-swim/id426826309',
};

export const GOOGLE_FIT_SOCIAL_LINKS = {
  googleStore: 'https://play.google.com/store/apps/details?id=com.google.android.apps.fitness',
  appleStore: 'https://apps.apple.com/in/app/google-fit-activity-tracker/id1433864494',
};

export const MAPMYRIDE_SOCIAL_LINKS = {
  googleStore: 'https://play.google.com/store/apps/details?id=com.mapmyride.android2',
  appleStore: 'https://apps.apple.com/us/app/map-my-ride-by-under-armour/id292223170',
};

export const MAPMYRUN_SOCIAL_LINKS = {
  googleStore: 'https://play.google.com/store/apps/details?id=com.mapmyrun.android2',
  appleStore: 'https://apps.apple.com/us/app/map-my-run-by-under-armour/id291890420',
};

export const FITBIT_SOCIAL_LINKS = {
  googleStore: 'https://play.google.com/store/apps/details?id=com.fitbit.FitbitMobile',
  appleStore: 'https://apps.apple.com/in/app/fitbit-health-fitness/id462638897',
};

export const POLAR_SOCIAL_LINKS = {
  googleStore: 'https://play.google.com/store/apps/details?id=fi.polar.polarflow',
  appleStore: 'https://apps.apple.com/us/app/polar-flow/id717172678',
};

export const WAHOO_SOCIAL_LINKS = {
  googleStore: 'https://play.google.com/store/apps/details?id=com.wahoofitness.fitness',
  appleStore: 'https://apps.apple.com/us/app/wahoo-fitness/id391599899',
};

export const AVAILABLE_INPUT_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const BUTTON_VARIANTS = {
  TEXT: 'text',
  CONTAINED: 'contained',
  OUTLINED: 'outlined',
};

export const BANNER_TYPE = {
  CARD: 'card',
  COVER: 'cover',
};

export const BANNER_PLATFORM = {
  WEB: 'web',
  MOBILE: 'mobile',
};

export const CURRENCY_AVAILABLE = {
  INR: 'INR',
  EUR: 'EUR',
  GBP: 'GBP',
  USD: 'USD',
};

export const EVENT_TYPE = {
  PHYSICAL: 'Physical',
  VIRTUAL: 'Virtual',
  BOTH: 'Both',
};

export const GST_IN_PRICE = {
  EXCLUDED: 'excluded',
  INCLUDED: 'included',
};

export const DATE_RANGE_FILTER_OPTIONS = {
  CURRENT_WEEK: 'currentWeek',
  NEXT_WEEK: 'nextWeek',
  CURRENT_MONTH: 'currentMonth',
  NEXT_MONTH: 'nextMonth',
};

export const AVAILABLE_DISTANCE_WIDGET_ID = {
  distance01: 'distance01',
  distance02: 'distance02',
  distance03: 'distance03',
  distance04: 'distance04',
};

export const AVAILABLE_TIME_WIDGET_ID = {
  time01: 'time01',
  time02: 'time02',
};

export const AVAILABLE_DAYS_WIDGET_ID = {
  day01: 'day01',
  day02: 'day02',
  day03: 'day03',
};

export const AVAILABLE_RANKS_WIDGET_ID = {
  rank01: 'rank01',
  rank02: 'rank02',
  rank03: 'rank03',
};

export const AVAILABLE_ATTEMPTS_WIDGET_ID = {
  attempts01: 'attempts01',
  attempts02: 'attempts02',
  attempts03: 'attempts03',
};

export const AVAILABLE_PACE_WIDGET_ID = {
  pace01: 'pace01',
  pace02: 'pace02',
};

export const AVAILABLE_SPEED_WIDGET_ID = {
  speed01: 'speed01',
};

export const AVAILABLE_TARGET_WIDGET_ID = {
  target01: 'target01',
};

export const AVAILABLE_POINTS_WIDGET_ID = {
  points01: 'points01',
};
export const AVAILABLE_CHALLENGES_WIDGET_ID = {
  challenge01: 'challenge01',
};

export const AVAILABLE_STEPS_WIDGET_ID = {
  steps01: 'steps01',
  steps02: 'steps02',
  steps03: 'steps03',
};

export const AVAILABLE_FINISHER_LEVEL_WIDGET_ID = {
  finisher01: 'finisher01',
  finisher02: 'finisher02',
};

export const AVAILABLE_TEAMS_WIDGET_ID = {
  team01: 'team01',
};

export const EVENT_ACTIVITY_LIST_WIDGETS = {
  ACTIVITIES01: 'activities01',
};

export const AVAILABLE_LEADERBOARD_WIDGET_ID = {
  leaderboard: 'leaderboard',
  leaderboardType: 'leaderboardType',
  reports: 'reports',
  reportsWithStages: 'reportsWithStages',
  teamReports: 'teamReports',
  stageReports: 'stageReports',
  teamStageReports: 'teamStageReports',
  teamReportsWithStages: 'teamReportsWithStages',
};

export const AVAILABLE_OVERALL_WIDGET_ID = {
  stage01: 'stage01',
  stage02: 'stage02',
  stage03: 'stage03',
  stage04: 'stage04',
  stage05: 'stage05',
  stage06: 'stage06',
  stage07: 'stage07',
  stage08: 'stage08',
};

export const AVAILABLE_CHALLENGES_TYPES = {
  beat_all_primary_challenges: 'beat_all_primary_challenges',
  beat_all_daily_goals: 'beat_all_daily_goals',
  event_all_days: 'event_all_days',
  event_milleage_challenge: 'event_milleage_challenge',
  event_steps_challenge: 'event_steps_challenge',
  event_points_challenge: 'event_points_challenge',
  adhoc: 'adhoc',
};

export const AVAILABLE_EVENT_CHALLENGES_WIDGETS = {
  eventChallenges: 'eventChallenges',
  adhocChallenges: 'adhocChallenges',
};

export const ADHOC_CHALLENGES_SPECIAL = 'special';
export const ADHOC_CHALLENGES_STEPPER = 'stepper';

export const INDIVIDUAL_ACTIVITY = [
  { label: 'Total Points', key: 'totalPoints' },
  { label: 'Challenges Completed', key: 'completedChallenges' },
  { label: 'Bonus Points', key: 'bonusPoints' },
  { label: 'Distance', key: 'totalDistance' },
];

// { label: "Duration", key: "duration" },
export const INDIVIDUAL_SUMMARY = [
  { label: 'Total Points', key: 'totalPoints' },
  { label: 'Challenges Completed', key: 'completedChallenges' },
  { label: 'Bonus Points', key: 'bonusPoints' },
  { label: 'Steps', key: 'totalSteps' },
];
export const INDIVIDUAL_SUMMARY_V2 = [
  { label: 'Total Points', key: 'totalPoints' },
  { label: 'Challenges Completed', key: 'completedChallenges' },
  { label: 'Bonus Points', key: 'bonusPoints' },
  { label: 'Steps', key: 'totalSteps' },
];
export const TEAM_ACTIVITY = [
  { label: 'Total Points', key: 'totalPoints' },
  { label: 'Challenges Completed', key: 'completedChallenges' },
  { label: 'Bonus Points', key: 'bonusPoints' },
  { label: 'Distance', key: 'totalDistance' },
];
export const TEAM_ACTIVITY_DISTANCE = [
  { label: 'Total Points', key: 'totalPoints' },
  { label: 'Challenges Completed', key: 'completedChallenges' },
  { label: 'Bonus Points', key: 'bonusPoints' },
  { label: 'Distance', key: 'totalDistance' },
];

export const TEAM_SUMMARY = [
  { label: 'Total Points', key: 'totalPoints' },
  { label: 'Challenges Completed', key: 'completedChallenges' },
  { label: 'Bonus Points', key: 'bonusPoints' },
  { label: 'Steps', key: 'totalSteps' },
];

export const TEAM_SUMMARY_POINTS = [
  { label: 'Total Points', key: 'totalPoints' },
  { label: 'Challenges Completed', key: 'completedChallenges' },
  { label: 'Bonus Points', key: 'bonusPoints' },
  { label: 'Steps', key: 'totalSteps' },
];

export const AVAILABLE_ELEVATION_GAIN_WIDGET_ID = {
  elevation01: 'elevation01',
};

export const AVAILABLE_HISTORIC_WIDGET_ID = {
  historicSummary01: 'historicSummary01',
  historicSummary02: 'historicSummary02',
  historicTrends01: 'historicTrends01',
};

export const AVAILABLE_SUMMARY_WIDGET_ID = {
  summary01: 'summary01',
};

export const AVAILABLE_ACHIEVEMENT_WIDGET_ID = {
  achievement01: 'achievement01',
};

export const RUN_SPLITS = [
  { label: 'Lap', key: 'lapNo' },
  { label: 'Distance (km)', key: 'distance' },
  { label: 'Time', key: 'lapTime' },
  { label: 'Pace(min/km)', key: 'strPace' },
  { label: 'Avg. Heart Rate', key: 'heartRate.average' },
];
// commented as mobile is not having this suggested by jay sir
// { label: "Avg. cadence", key: "cadence.average" },
export const RIDE_SPLITS = [
  { label: 'Lap', key: 'lapNo' },
  { label: 'Distance (km)', key: 'distance' },
  { label: 'Time', key: 'lapTime' },
  { label: 'Lap speed(km/h)', key: 'speed' },
  { label: 'Avg. Heart Rate', key: 'heartRate.average' },
];
export const STEPS_SPLITS = [
  { label: 'Start time', key: 'startTime' },
  { label: 'End time', key: 'endTime' },
  { label: 'Steps count', key: 'steps' },
];
export const decimalNumberRegEx = new RegExp('^[0-9.]*$');
export const numericRegEx = new RegExp('^[0-9]*$');
export const alphaNumeric = new RegExp('^[a-zA-Z0-9. -]*$');
export const alphaNumericName = new RegExp('^[a-zA-Z0-9. -]*$');
export const alphaNumericSpecialCharacters = new RegExp("^[a-zA-Z0-9.@!#$&'*+-/=?_ -]*$");
export const alphaNumericPassword = new RegExp("^[a-zA-Z0-9.@!#$&'*+-/=?_ -]*$");
export const alphaNumericEmail = new RegExp("^[a-zA-Z0-9(),:@!#$%&'*+-/=?^_`{|}~]*$");
